import { SEASONS_LIST_LIMIT } from "@/lib/constants";
import { useAuth } from "@/contexts/auth";
import { useSeasonsClient } from "@/features/seasons/hooks/use-seasons-client";
import { normalizeSeason } from "@/features/seasons/lib/season-settings";
import { seasonsQueryKeys } from "@/features/seasons/queries/seasons-query-keys";
import { useInfiniteQuery } from "@tanstack/react-query";

export function useSeasonsListQuery({
  sport,
  organizationId,
  search,
}: {
  sport: string;
  organizationId: string;
  search?: string;
}) {
  const { productToken } = useAuth();
  const seasonsClient = useSeasonsClient();
  const nameContains = search?.trim() || undefined;

  return useInfiniteQuery({
    queryKey: seasonsQueryKeys.list({ sport, organizationId, search: nameContains ?? "" }),
    queryFn: async ({ pageParam }) => {
      const response = await seasonsClient.getSeasonsList({
        productToken: productToken as string,
        sport,
        organizationId,
        limit: SEASONS_LIST_LIMIT,
        offset: pageParam,
        nameContains,
      });

      return Array.isArray(response.data) ? response.data.map(normalizeSeason) : [];
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, _pages, lastPageParam) => {
      if (lastPage.length < SEASONS_LIST_LIMIT) {
        return undefined;
      }

      return lastPageParam + SEASONS_LIST_LIMIT;
    },
    enabled: !!productToken && !!sport && !!organizationId,
  });
}
